<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>To Catch a Thief</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<div class="frontMatterPage" id="frm01"><div class="chapterHead"><h2 class="chapterTitle1"> </h2></div><div class="chapterBody"><p class="paraNoIndent1"><span>Dear Reader,</span></p><p class="paraNoIndent1"><span>Some characters you never forget.</span></p><p class="paraNoIndent1"><span>Some stories grip you from the first word, locked deep in the heart. For me, that love struck with a great gray cat, a brooding English abbey and its aristocratic guardian ghost, Adrian Draycott.</span></p><p class="paraNoIndent1"><span>I’ve walked through eight books and two novellas set at the abbey now. Each story brings more secrets and the heady scent of rich heritage roses climbing up tower and parapet.</span></p><p class="paraNoIndent1"><span>Dangerous magic.</span></p><p class="paraNoIndent"><span>White-hot passion.</span></p><p class="paraNoIndent"><span>Undying love.</span></p><p class="paraNoIndent1"><span>How could any writer resist?</span></p><p class="paraNoIndent1"><span>And just to keep the tension hot, I’ve brought a rugged Navy SEAL from my Code Name series to the abbey, locked in pursuit of a vicious enemy.</span></p><p class="paraNoIndent1"><span>I hope you enjoy the adventure.</span></p><p class="paraNoIndent1"><span>See you at the abbey.</span></p><p class="paraNoIndent1"><span><em class="italic"><span>Christina</span></em></span></p></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tocatchathief_frm01.vue?2dd3ab82